import * as React from "react";

const SvgIcnSpeechSearchesBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M14 9a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 9zm0 1a3 3 0 100 6 3 3 0 000-6zm-.377-5C14.383 5 15 5.619 15 6.382l.001 1.718A5.023 5.023 0 0014 8a4.978 4.978 0 00-3 1H6.5a.5.5 0 00-.09.992L6.5 10H10a4.996 4.996 0 00-.584 1H6.5a.5.5 0 00-.09.992L6.5 12h2.6a5.023 5.023 0 00-.007 1.965H7.111l-1.95 1.847A.687.687 0 014 15.309V6.382A1.38 1.38 0 015.377 5h8.246zM12.5 7h-6a.5.5 0 00-.09.992L6.5 8h6a.5.5 0 000-1z"
        />
    </svg>
);

export default SvgIcnSpeechSearchesBold;
